import React from 'react';
import { connect } from 'react-redux';
import { Spinner } from 'react-bootstrap';

import CompProduct from './store/CompProduct';
import CompCart from './store/CompCart';

function CompStore(props) {
  const { next } = props.navigation;

  return (
    <>
      {props.store.products.length > 0 &&
        <div className="mt-3 clearfix">
          <CompCart
            language={props.language}
            store={props.store}
            cart={props.cart}
            addPromotionalCode={props.addPromotionalCode}
            clearCart={props.clearCart}
            next={next}
          />
          {props.pendingTasks ?
            <div className="text-center mt-5">
              <Spinner
                style={{ width: "5rem", height: "5rem" }}
                as="span"
                animation="border"
                role="status"
                aria-hidden="true"
              />
            </div>
            :
            props.store.products.filter((product) => {
              if (props.cart.products.length > 0) {
                let uniqueProduct = props.cart.products.find((cartProduct) =>
                  cartProduct.multiple === "N"
                );
                if (uniqueProduct) {
                  if (uniqueProduct.idsubitems === product.idsubitems) {
                    return product;
                  } else {
                    return false;
                  }
                } else {
                  if (product.multiplaescolha === "N") {
                    return false;
                  }
                }
              }
              return product;
            }).map((product) =>
              <CompProduct
                key={product.idsubitems}
                language={props.language}
                product={product}
                cart={props.cart}
                addProductCart={props.addProductCart}
                removeProductCart={props.removeProductCart} />
            )}
        </div>
      }
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    trads: state.reducerTraducoes,
    pendingTasks: state.pendingTasks
  };
}
export default connect(mapStateToProps)(CompStore);